import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Space,
  Button,
  Breadcrumb,
  Form,
  theme,
  Divider,
  Input,
  Select,
} from "antd";
import _ from "lodash";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useAuth from "../../../lib/hooks/useAuth";
import { routes } from "../../../routes";
import Heading from "../../../components/common/heading";
import WithSidebar from "../../../templates/withSidebar";
import SuccessModal from "../../../components/modal/successModal";
import FailModal from "../../../components/modal/failModal";
import {
  getIndicatorById,
  getListDepartments,
  getListDivisions,
  updateIndicatorsData,
  getListIndicators,
  getIndicatorByYearlyPlan,
} from "../../../services/progressPerformance";
import { SUCCESS_CODE, ERR_0022 } from "../../../lib/const";

const { useToken } = theme;
const { Option } = Select;

export const EditIndicator = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const { auth } = useAuth();
  const params = useParams();
  const [form] = Form.useForm();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [data, setData] = useState({});
  const [dropDownDepartment, setDropDownDepartment] = useState([]);
  const [dropDownDivision, setDropDownDivision] = useState([]);
  const [listIndicators, setListIndicators] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [divisionId, setDivisionId] = useState();
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [year, setYear] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const years = moment().add(1, "years").format("YYYY");
  const yearArray = [
    parseInt(years),
    parseInt(years - 1),
    parseInt(years - 2),
    parseInt(years - 3),
    parseInt(years - 4),
  ];

  const getPermission =
    auth?.user?.permissions &&
    _.get(
      auth?.user?.permissions.find(
        (item) => item.permissionName === "Application field"
      ),
      "permissionList",
      []
    ).find(
      (item) => item.pageName === "รายงานผลตัวชี้วัด" && _.get(item,"customPermission['Access all years of budget']",false) === true
    );

  const createPermission =
    auth?.user?.permissions &&
    _.get(
      auth?.user?.permissions.find(
        (item) => item.permissionName === "Application field"
      ),
      "permissionList",
      []
    ).find(
      (item) => item.pageName === "รายงานผลตัวชี้วัด" && _.get(item,"customPermission['Create/Update']",false) === true
    );

  // const [indicatorId, setIndicatorId] = useState();
  const months = [
    {
      value: "10",
      name: "ตุลาคม",
    },
    {
      value: "11",
      name: "พฤศจิกายน",
    },
    {
      value: "12",
      name: "ธันวาคม",
    },
    {
      value: "1",
      name: "มกราคม",
    },
    {
      value: "2",
      name: "กุมภาพันธ์",
    },
    {
      value: "3",
      name: "มีนาคม",
    },
    {
      value: "4",
      name: "เมษายน",
    },
    {
      value: "5",
      name: "พฤษภาคม",
    },
    {
      value: "6",
      name: "มิถุนายน",
    },
    {
      value: "7",
      name: "กรกฎาคม",
    },
    {
      value: "8",
      name: "สิงหาคม",
    },
    {
      value: "9",
      name: "กันยายน",
    },
  ];

  const handleChange = (value) => {
    setDepartmentId(value);
    form.setFields([
      {
        name: "name",
        value: undefined,
      },
      {
        name: "divisionId",
        value: undefined,
      },
      {
        name: "indicatorId",
        value: undefined,
      },
    ]);
  };

  const onFinish = async (values) => {
    const year = Number(values.yearOfBudget) + 543;

    const request = {
      indicatorId: values.indicatorId,
      departmentId: values.departmentId,
      divisionId: values.divisionId,
      monthOfBudget: values.monthOfBudget,
      yearOfBudget: values.yearOfBudget,
      monthlyValue: values.monthlyIndicator,
      quarterlyForecast: values.quarterlyForecast,
      annualForecast: values.annualForecast,
      status: data?.status ? "true" : "false",
    };

    const res = await updateIndicatorsData(params.id, request);
    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setTimeout(() => {
        navigate(routes.progress_tab_indicator);
        setSuccessModal(false);
      }, 2000);
    } else {
      if (res.data.code === ERR_0022) {
        setFailModal(true);
        setErrorMessage("ตัวชี้วัดดังกล่าวมีอยู่ในระบบเรียบร้อยแล้ว");
      } else {
        setErrorMessage("");
        setFailModal(true);
        setTimeout(() => {
          setFailModal(false);
        }, 2000);
      }
    }
  };

  const fetchIndicatorById = useCallback(
    async (id) => {
      const res = await getIndicatorById(id);
      if (res.data.code === SUCCESS_CODE) {
        const { objectValue } = res.data;
        setData(objectValue);
        setDepartmentId(objectValue?.departmentId);

        form.setFieldsValue({
          indicatorId: objectValue?.indicatorId,
          departmentId: objectValue?.departmentId,
          divisionId: objectValue?.divisionId,
          divisionNameTh: objectValue?.divisionNameTh,
          monthOfBudget: objectValue?.monthOfBudget,
          yearOfBudget: objectValue?.yearOfBudget,
          monthlyIndicator: objectValue?.monthlyValue,
          quarterlyForecast: objectValue?.quarterlyForecast,
          annualForecast: objectValue?.annualForecast,
        });
      }
    },
    [setData]
  );

  const fetchListDepartments = useCallback(async () => {
    try {
      const res = await getListDepartments();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDepartment(result_data);
      }
    } catch (error) {}
  }, [dropDownDepartment]);

  const fetchListDivisions = useCallback(async () => {
    try {
      const res = await getListDivisions(departmentId);

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDivision(result_data);
      }
    } catch (error) {}
  }, [departmentId]);

  const fetchListIndicators = useCallback(async () => {
    try {
      //const res = await getListIndicators(departmentId);

      const request = {
              departmentId: form.getFieldValue().departmentId
                ? form.getFieldValue().departmentId
                : "",
              divisionId: form.getFieldValue().divisionId
                ? form.getFieldValue().divisionId
                : "",
              yearOfBudget: form.getFieldValue().yearOfBudget
                ? form.getFieldValue().yearOfBudget
                : "",
            };
      const res = await getIndicatorByYearlyPlan(request);


      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setListIndicators(result_data);
      }
    } catch (error) {}
  }, [listIndicators, departmentId]);

  const fetchIndicatorByYearlyPlan = useCallback(async () => {
    try {
      const request = {
        departmentId: form.getFieldValue().departmentId
          ? form.getFieldValue().departmentId
          : "",
        divisionId: form.getFieldValue().divisionId
          ? form.getFieldValue().divisionId
          : "",
        yearOfBudget: form.getFieldValue().yearOfBudget
          ? form.getFieldValue().yearOfBudget
          : "",
      };
      const res = await getIndicatorByYearlyPlan(request);

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setListIndicators(result_data);
      }
    } catch (error) {}
  }, [departmentId, divisionId, year]);

  useEffect(() => {
    fetchIndicatorByYearlyPlan();
  }, [departmentId, divisionId, year]);

  useEffect(() => {
    fetchIndicatorById(params.id);
  }, [params.id, fetchIndicatorById]);

  useEffect(() => {
    fetchListDepartments();
  }, []);

  useEffect(() => {
    if (departmentId) {
      fetchListIndicators();
    }
  }, [departmentId]);

  useEffect(() => {
    if (departmentId) {
      fetchListDivisions();
    }
  }, [departmentId]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.progress_tab_indicator);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"แก้ไขข้อมูล"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลตัวชี้วัด",
                },
                {
                  title: "รายละเอียด",
                },
                {
                  title: <span className="pr_green">แก้ไขข้อมูล</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
              disabled={!createPermission}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.progress_tab_indicator);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit"
                    >
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Heading
                        text={"ตัวชี้วัด"}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                  </Row>
                  <Divider />
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ปีงบประมาณ"
                    name={"yearOfBudget"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    {getPermission ? (
                      <Select
                        allowClear
                        style={{
                          width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        maxTagCount={"responsive"}
                        onChange={() => {
                          let arr = form.getFieldValue().yearOfBudget;
                          setYear(arr);
                          form.setFields([
                            {
                              name: "indicatorId",
                              value: undefined,
                            },
                          ]);
                        }}
                        // disabled
                        value={year}
                      >
                        {yearArray.map((item) => (
                          <Option value={parseInt(item) + 543}>
                            {parseInt(item) + 543}
                          </Option>
                        ))}
                      </Select>
                    ) : (
                      <Input placeholder="ปีงบประมาณ" disabled />
                    )}
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="เดือนงบประมาณ"
                    name={"monthOfBudget"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      // maxTagCount={"responsive"}
                    >
                      {months.map((m) => (
                        <Option value={m.value}>{m.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ฝ่าย"
                    name={"departmentId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={handleChange}
                    >
                      {dropDownDepartment.map((option) => (
                        <Option value={option.departmentId}>
                          {option.departmentNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="กอง"
                    name={"divisionId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={(e) => {
                        setDivisionId(e);
                        form.setFields([
                          {
                            name: "indicatorId",
                            value: undefined,
                          },
                        ]);
                      }}
                    >
                      {dropDownDivision.map((item) => (
                        <Option value={item.divisionId}>
                          {item.divisionNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ตัวชี้วัดยุทธศาสตร์"
                    name={"indicatorId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {listIndicators.map((item) => (
                        <Option value={item.indicatorId}>
                          {item.indicatorNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[3, 16]}>
                    <Col span={24}>
                      <Form.Item
                        label="ผลค่าตัวชี้วัดประจำเดือน"
                        name={"monthlyIndicator"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input placeholder="ค่าตัวชี้วัดยุทธศาสตร์ประจำเดือน" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="คาดการณ์ ผลตัวชี้วัด ณ สิ้นไตรมาส"
                        name={"quarterlyForecast"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input placeholder="ค่าผลคาดการณ์ผลตัวชี้วัดยุทธศาสตร์ ณ สิ้นไตรมาส" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="คาดการณ์ ผลตัวชี้วัด ณ สิ้นปีงบประมาณ"
                        name={"annualForecast"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input placeholder="ค่าผลคาดการณ์ผลตัวชี้วัดยุทธศาสตร์ ณ สิ้นปีงบประมาณ" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        title={errorMessage ? errorMessage : ""}
        subTitle={errorMessage ? "กรุณาทำการตรวจสอบข้อมูล" : ""}
        open={failModal}
        setOpen={setFailModal}
        setErrMsg={setErrorMessage}
      />
    </WithSidebar>
  );
};
